import {
    Button, CardHeader,
    Grid, Input,
    Paper
} from "@mui/material";
import { withStyles } from "@mui/styles";
import axios from "axios";
import { createForm } from "rc-form";
import * as React from "react";
import {LoadingWrapper} from "../../components/LoadingWrapper";
import {Config} from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";

interface TranslationsState {
    translations: {};
    values: any[],
    results: string[];
    loading: boolean,
}

interface TranslationsProps {
    activeUser: any;
    activeEnv: any;
    classes: any;
    form: any;
}

class TranslationsWrapped extends React.Component<TranslationsProps, TranslationsState> {
    sending = false;
    rewardItems: any;

    constructor(props) {
        super(props);

        this.state = {
            translations: {},
            values: [],
            results: [],
            loading: false,
        };
        document.title = Helpers.documentTitle("Translations");
        this.fetchTranslations();
    }

    async fetchTranslations() {
        try {
            const response = await axios.get(`${Config.getInstance.apiUrl}/api/translations`, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });

            this.setState({
                translations: response.data.data,
            });
        } catch (e) {
            PopupMessage.error("Failed to save translation record! Error: " + e.message);
        }
    }

    addTranslationKey = () => {
        const values = [
            ...this.state.values,
        ];
        values.push({
            key: "",
            value: "",
        });

        this.setState({
            values,
        });
    }

    saveKeys = async () => {

        this.setState({
            loading: true,
        });

        try {
            await axios.post(`${Config.getInstance.apiUrl}/api/translations`, {
                values: this.state.values,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });
            this.setState({
                values: [],
            });
            await this.fetchTranslations();
            PopupMessage.success("Translation keys added!");
        } catch (e) {
            PopupMessage.error("Failed to save translation record! Error: " + e.message);
        }

        this.setState({
            loading: false,
        });
    }

    keyChanged = (e) => {
        const values = [
            ...this.state.values,
        ]
        const index = parseInt(e.target.name.replace("key-", ""), 10);
        values[index].key = e.target.value;
        this.setState({
            values,
        });
    }

    valueChanged = (e) => {
        const values = [
            ...this.state.values,
        ]
        const index = parseInt(e.target.name.replace("value-", ""), 10);
        values[index].value = e.target.value;
        this.setState({
            values,
        });
    }

    exportTranslations = async () => {
        this.setState({
            loading: true,
        });
        try {
            const response = await axios.post(`${Config.getInstance.apiUrl}/api/translations/export`, {}, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });
            PopupMessage.success(`Translations exported! In total ${response.data.data.length} files generated!`);
            this.fetchTranslations();
        } catch (e) {
            PopupMessage.error("Failed to save translation record! Error: " + e.message);
        }

        this.setState({
            loading: false,
        });
    }

    renderSimilarResults() {
        const items = [];
        this.state.results.forEach(key => {
            items.push((
                <div>
                    <div style={{padding: "5px"}}>
                        {key}
                    </div>
                </div>
            ));
        });

        if (items.length > 0) {
            return [
                (
                    <div style={{fontWeight: "bold"}}>
                        Similar keys:
                    </div>
                ),
                ...items,
            ];
        }

        return items;
    }

    renderTranslations() {
        return (
            <div style={{padding: 20}}>
                Total keys: {Object.keys(this.state.translations).length}
            </div>
        )
    }

    renderTranslationFields() {
        return this.state.values.map((item, index) => (
            <div style={{padding: 20}}>
                <div style={{padding: 20}}>
                    <Input
                        value={item.key}
                        name={`key-${index}`}
                        placeholder="Translation key"
                        onChange={this.keyChanged}
                    />
                </div>
                <div style={{padding: 20}}>
                    <Input
                        value={item.value}
                        name={`value-${index}`}
                        placeholder="Translation value"
                        onChange={this.valueChanged}
                    />
                </div>
            </div>
        ))
    }

    render() {
        const {classes} = this.props;

        return (
            <div className="contentPadding">
                <Grid container spacing={0}>
                    <Paper className="root" style={{padding: 14}} elevation={0}>
                        <Grid item xs={12}>
                            <CardHeader
                                title="Translations"
                                action={
                                    <React.Fragment>
                                        <LoadingWrapper loading={this.state.loading}>
                                            <Button disableElevation
                                                color="primary"
                                                variant="contained"
                                                onClick={this.exportTranslations}
                                            >
                                                Export translations
                                            </Button>
                                        </LoadingWrapper>
                                    </React.Fragment>
                                }
                            />
                            <Grid item xs={6} style={{float: "left"}}>
                                {this.renderTranslations()}
                                <div style={{padding: 20}}>
                                    {this.renderTranslationFields()}
                                    <div style={{padding: 20}}>
                                        <LoadingWrapper loading={this.state.loading}>
                                            <Button disableElevation
                                                onClick={this.addTranslationKey}
                                                variant="contained"
                                            >
                                                Add new translation key
                                            </Button>
                                        </LoadingWrapper>
                                    </div>
                                </div>
                                <div style={{padding: 20}}>
                                    <div style={{padding: 20}}>
                                        <LoadingWrapper loading={this.state.loading}>
                                            <Button disableElevation
                                                onClick={this.saveKeys}
                                                variant="contained"
                                                color="primary"
                                            >
                                                Save keys
                                            </Button>
                                        </LoadingWrapper>
                                    </div>
                                </div>
                            </Grid>

                            <Grid item xs={6} style={{float: "left"}}>
                                {this.renderSimilarResults()}
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </div>
        );
    }
}

const styles: any = theme => ({
    actions: {
        color: theme.palette.text.secondary,
        float: "right",
    },
    button: {
        margin: 8,
    },
});

export const Translations = createForm()(withStyles(styles)(TranslationsWrapped));
